<template>
  <v-container tag="section" fluid>
    <validation-observer ref="observer" v-slot="{ invalid }" slim>
      <v-row cols="12">
        <v-col col="12" class="pb-2">
          <parametros-joa ref="parametrosJoa" />
        </v-col>
        <v-col cols="12">
          <v-btn
            id="btn-save-joa"
            color="success"
            min-width="100"
            style="float: right"
            :disabled="invalid"
            :loading="loading"
            @click="salvarJoa()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>
<script>
  import JoaService from '@/services/JoaService.js';

  export default {
    name: 'JoaEdit',

    components: {
      ParametrosJoa: () => import('@/components/joa/ParametrosJoa.vue')
    },

    data: () => ({
      loading: false
    }),

    methods: {
      salvarJoa() {
        this.loading = true;
        const postData = this.$refs.parametrosJoa.dadosJoa;
        JoaService.salvar(postData)
          .then((response) => {
            this.$toast.success(response.data.msg, '', { position: 'topRight' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar...', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
